import { ReactiveVar } from '@apollo/client';
import { isEditModeVar } from '../../../vars/isEditModeVar';
const updateEditMode = (editMode: ReactiveVar<boolean>) => {
  return (isEditMode: boolean) => editMode(isEditMode);
};

export const editModeMutations = {
  updateEditMode: updateEditMode(isEditModeVar)
}